import styled, { css } from 'styled-components';
import { StatusTagProps } from './StatusTag.component';

type StatusType = Omit<StatusTagProps, 'status'> & {
  statusColor: string;
  colored?: boolean;
  outlined?: boolean;
};

const coloredStatus = css<StatusType>`
  color: ${(props) => props.statusColor};
`;

const outlinedStatus = css<StatusType>`
  border-radius: 5px;
  padding: 0px 5px;
  border: 1px solid;
  border-color: ${(props) => props.statusColor};
  font-weight: 600;
  font-size: 12px;
  line-height: 16.32px;
  display: inline-block;

  ${coloredStatus}
  &:before {
    display: none;
  }
  .placeholder {
    opacity: 0;
    display: block;
  }
  .displayed {
    position: absolute;
    height: 0;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    line-height: 0;
    width: 100%;
    text-align: center;
    height: 18px;
    line-height: 18px;
  }
`;

const dotStatus = css<StatusType>`
  padding-left: 10px;
  position: relative;
  &:before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    background: ${(props) => props.statusColor};
    left: 0;
  }
`;

export const Status = styled.p<StatusType>`
  font-weight: 400;
  font-size: 14px;
  height: 20px;
  position: relative;
  color: ${(props) => props.theme.colors['neutral-100']};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .placeholder {
    display: none;
  }
  .displayed {
    position: relative;
    top: 1px;
  }
  ${dotStatus};
  ${(props) => props.colored && coloredStatus};
  ${(props) => props.outlined && outlinedStatus};
`;
